import React from 'react';

const QuantityLine = (order) => {
  return (
    <td colspan="1">{order?.items?.reduce((a, b) => { return a + b.quantity; }, 0)}</td>
  );
};

export default QuantityLine;
